import React from 'react';

// Функции для работы с данными сайта
const getSiteDataFunctions = {
  // Функция для поиска main_tab элемента
  findMainTabElement: (data) => {
    let mainTabElement = null;
    if (data && data.tabs) {
      for (let i = 0; i < data.tabs.length; i++) {
        const element = data.tabs[i];
        if (element.eng_name === 'main_tab') {
          mainTabElement = element;
          break;
        }
      }
    }
    return mainTabElement;
  },

  // Функция для обработки пути
  processPath: (currentPath, data, mainTabElement) => {
    const pathArray = currentPath.split('/');

    let currentTabPath = '';
    let currentPublicationPath = '';

    if (pathArray.length === 2 && pathArray[0] === '' && pathArray[1] === '') {
      // В этом случае мы находимся на главной странице
      currentTabPath = '/';
    } else if (pathArray.length === 2 && pathArray[1] !== '') {
      // Здесь проверяем открыт стол, публикация на главной странице или страницы не существует
      let foundMatch = false;
      if (data && data.tabs) {
        for (let i = 0; i < data.tabs.length; i++) {
          const element = data.tabs[i];
          if (element.eng_name === pathArray[1]) {
            foundMatch = true;
            break;
          }
        }
      }

      if (foundMatch) {
        currentTabPath = '/' + pathArray[1];
      } else {
        currentTabPath = '/';

        // Если foundMatch === false, проверяем через цикл mainTabElement
        if (mainTabElement && mainTabElement.publications) {
          for (let i = 0; i < mainTabElement.publications.length; i++) {
            const element = mainTabElement.publications[i];
            if (element.eng_name === pathArray[1]) {
              currentPublicationPath = pathArray[1];
              break;
            }
          }
        }
      }
    } else if (pathArray.length > 2) {
      // В этом случае мы находимся на странице публикации не главной страницы,или страницы не существует
      let foundMatch = false;
      let MatchTab = null;
      if (data && data.tabs) {
        for (let i = 0; i < data.tabs.length; i++) {
          const element = data.tabs[i];
          if (element.eng_name === pathArray[1]) {
            foundMatch = true;
            MatchTab = element;
            break;
          }
        }
      }

      if (foundMatch) {
        currentTabPath = '/' + pathArray[1];
        // Проверяем все MatchTab.publications на совпадение pathArray[2] с элементом.eng_name
        let foundPublicationMatch = false;
        if (MatchTab && MatchTab.publications) {
          for (let i = 0; i < MatchTab.publications.length; i++) {
            const element = MatchTab.publications[i];
            if (element.eng_name === pathArray[2]) {
              foundPublicationMatch = true;
              currentPublicationPath = pathArray[2];
              break;
            }
          }
        }
      } else {
        currentTabPath = '/';
      }
    }

    return {
      currentTabPath,
      currentPublicationPath,
      pathArray,
    };
  },
};

export default getSiteDataFunctions;
